import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

/*
* Link Service use to append/inject specific elements into the documents head.
*/

export class LinkService {

  constructor(@Inject(DOCUMENT) private doc: Document, @Inject(PLATFORM_ID) private platformId: Object) { }

  createLink(href: string, rel: string, type: string) {
    if (isPlatformBrowser(this.platformId)) {
      let link: HTMLLinkElement = this.doc.createElement('link');
      link.setAttribute('href', href);
      link.setAttribute('rel', rel);
      link.setAttribute('as', type);
      this.doc.head.appendChild(link);
    }
  }
}
